// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3949":"a962d6437b2aafb4","7383":"7f5ff0cf81652905","8025":"3be5d91bcff71d40"}[chunkId] + ".css";
};